'use client';

import { Box, Typography } from '@mui/material';

// Deep import, not the '@/components' barrel: this module is in the always-rendered
// graph, where a barrel import pulls the whole component tree (charts included).
import { Logo } from '@/components/common/Logo';
import { useT } from '@/hooks';

export const FooterBrand = () => {
  const { t } = useT();
  return (
    <Box sx={{ mb: { xs: 1.5, md: 0 } }}>
      <Box sx={{ mb: { xs: 1, md: 2 }, display: 'flex', alignItems: 'center' }}>
        <Logo iconSize={32} fontSize="2rem" />
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: { xs: '100%', md: 300 }, lineHeight: 1.7, opacity: 0.8 }}
      >
        {t('footer.brandDesc')}
      </Typography>
    </Box>
  );
};
